import _ from 'lodash';

function MLHVQDiscrepanciesUtil() {
    const DISCREPANCY_PROPERTY_DTO = 'metlife.edge.capabilities.quote.discrepancies.dto.HVQDiscrepancyPropertyDTOML';
    const DISCREPANCY_ITEM_DTOS = {
        DRIVER: 'metlife.edge.capabilities.quote.discrepancies.lob.personalauto.drivers.dto.HVQDiscrepancyDriverDTOML',
        VEHICLE: 'metlife.edge.capabilities.quote.discrepancies.lob.personalauto.vehicles.dto.HVQDiscrepancyVehicleDTOML',
        PRIOR_CARRIER: 'metlife.edge.capabilities.quote.discrepancies.lob.personalauto.priorcarrier.dto.HVQDiscrepancyPriorCarrierDTOML',
        DWELLING: 'metlife.edge.capabilities.quote.discrepancies.lob.homeowners.dwelling.dto.HVQDiscrepancyDwellingDTOML',
    };

    const _isVMType = (objVM, type) => objVM._metadataInfo.valueType.name === type;

    const _toVMArray = (vmList) => {
        if (!vmList || !vmList.value) {
            return [];
        }
        return vmList.filter(() => true);
    };

    const _isDiscrepancyPropertyDTO = (objVM) => {
        return _isVMType(objVM, DISCREPANCY_PROPERTY_DTO);
    };

    const getLOBDiscrepancyItemVMs = (submissionVM) => {
        let discrepancyItems = [];
        if (submissionVM.value.isPersonalAuto()) {
            discrepancyItems = _toVMArray(submissionVM?.hvqDiscrepancies_ML?.personalAuto?.drivers)
                .concat(_toVMArray(submissionVM?.hvqDiscrepancies_ML?.personalAuto?.vehicles))
                .concat(_toVMArray(submissionVM?.hvqDiscrepancies_ML?.personalAuto?.priorCarriers));
        } else if (submissionVM.value.isHomeOwners()) {
            discrepancyItems = _toVMArray(submissionVM?.hvqDiscrepancies_ML?.homeowners?.dwellings);
        } else {
            console.warn('Could not retrieve discrepancy items due to invalid LOB (must be Auto or Home)');
        }
        console.log(`discrepancyItems: ${discrepancyItems?.length}`);
        return discrepancyItems.filter((vmItem) => !!vmItem && _.get(vmItem, "hasSolvedAllHVQDiscrepancies.value") === false);
    };

    const getPropertyVMsFromVMItem = (discrepancyItemVM) => {
        const discrepancyItem = discrepancyItemVM.value;
        let discrepancyPropertyVMs = [];
        if (discrepancyItem) {
            const subProperties = Object.keys(discrepancyItem);
            discrepancyPropertyVMs = subProperties
                .map((property) => discrepancyItemVM[property])
                .filter((itemPropertyVM) => _isDiscrepancyPropertyDTO(itemPropertyVM));
        }
        return discrepancyPropertyVMs;
    };

    const getLOBPendingDiscrepancyItemVMs = (submissionVM) => {
        const discrepancyItemVMs = getLOBDiscrepancyItemVMs(submissionVM);
        return discrepancyItemVMs
            .filter((vmItem) => getPropertyVMsFromVMItem(vmItem).length > 0);
    };

    const hasDiscrepancies = (submissionVM) => !!getLOBPendingDiscrepancyItemVMs(submissionVM).length;

    const markDiscrepancyItemCompleted = (discrepancyItemVM) => {
        discrepancyItemVM.hasSolvedAllHVQDiscrepancies.value = true;
    };

    const markAllDiscrepancyItemsCompleted = (submissionVM) => {
        const discrepancyItems = getLOBDiscrepancyItemVMs(submissionVM);
        discrepancyItems
            .forEach((itemVM) => markDiscrepancyItemCompleted(itemVM));
    };

    const getPropertyVMsFromVMItemWithDefaultSelection = (vmItem, defaultToHvqValue = true) => {
        const propertyVMs = getPropertyVMsFromVMItem(vmItem);
        propertyVMs.forEach((propertyVM) => {
            propertyVM.value.keepHvqValue = defaultToHvqValue
        });
        return propertyVMs;
    };

    return {
        getLOBDiscrepancyItemVMs,
        getLOBPendingDiscrepancyItemVMs,
        hasDiscrepancies,
        markAllDiscrepancyItemsCompleted,
        markDiscrepancyItemCompleted,
        getPropertyVMsFromVMItem,
        getPropertyVMsFromVMItemWithDefaultSelection,
        isDriverItemVM: (itemVM) => _isVMType(itemVM, DISCREPANCY_ITEM_DTOS.DRIVER),
        isVehicleItemVM: (itemVM) => _isVMType(itemVM, DISCREPANCY_ITEM_DTOS.VEHICLE),
        isPriorCarrierItemVM: (itemVM) => _isVMType(itemVM, DISCREPANCY_ITEM_DTOS.PRIOR_CARRIER),
        isDwellingItemVM: (itemVM) => _isVMType(itemVM, DISCREPANCY_ITEM_DTOS.DWELLING),
    };
};

export default MLHVQDiscrepanciesUtil;

